import { NgModule } from '@angular/core';

import { CbpNumberRequestBusinessTypeFormComponent, CbpNumberRequestIdentifierTypeFormComponent } from './components';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MutualModule } from '@shared/mutual/mutual.module';
import { CardsModule } from '@shared/cards/cards.module';

@NgModule({
  declarations: [CbpNumberRequestBusinessTypeFormComponent, CbpNumberRequestIdentifierTypeFormComponent],
  imports: [CommonModule, RouterModule, CardsModule, MutualModule],
  exports: [CbpNumberRequestBusinessTypeFormComponent, CbpNumberRequestIdentifierTypeFormComponent],
})
export class CbpNumberRequestSharedModule {}
